const hydrate = (_options) => {
  const codeBlocks = document.querySelectorAll(
    `[data-scalar-type="code-block-copy"]`
  );
  codeBlocks.forEach((element) => {
    if (!element.hasAttribute("hydrated")) {
      element.addEventListener(
        "click",
        () => handleCodeBlockCopy(element)
      );
      element.setAttribute("hydrated", "true");
    }
  });
  return true;
};
function handleCodeBlockCopy(element) {
  const content = element.parentElement?.querySelector("pre")?.innerText;
  if (content) navigator.clipboard.writeText(content);
  element.classList.add("show-copied");
  setTimeout(() => element?.classList.remove("show-copied"), 1200);
}
export {
  hydrate
};
//# sourceMappingURL=hydration.js.map
